import { GeoItem } from "./geo-item"
import { TrackingData } from "./tracking-data"

export class SearchboxModelv2 {
    trackingData: TrackingData
    startDate: string
    endDate: string
    startTime: string
    endTime: string
    origin: GeoItem
    destination: GeoItem
    addReturn: boolean
    transferType: string
    passengers: string
  }